module.exports = __webpack_public_path__ + "img/icons_33.dc87ac2a.svg";